import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnchor2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnchor2"><Path d="M12 21.25V8.75M18.1622 12H21.5C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12H5.83784M12 8.5C13.6569 8.5 15 7.15685 15 5.5C15 3.84315 13.6569 2.5 12 2.5C10.3431 2.5 9 3.84315 9 5.5C9 7.15685 10.3431 8.5 12 8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnchor2;
